import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';

export class BaseProductsDirective {
  private hasView = false;

  showViewBasedOnCondition(condition: boolean) {
    if (condition && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!condition && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    public authenticationService: GtAuthenticationService
  ) {}
}

@Directive({
  selector: '[gtHasOneOf]'
})
export class GtHasOneOfProductsDirective extends BaseProductsDirective {
  @Input() set gtHasOneOf(parameters: any[]) {
    if (!parameters) {
      return;
    }
    this.authenticationService.hasOneOf(...parameters).subscribe(condition => this.showViewBasedOnCondition(condition));
  }

  constructor(templateRef: TemplateRef<any>, viewContainer: ViewContainerRef, authenticationService: GtAuthenticationService) {
    super(templateRef, viewContainer, authenticationService);
  }
}

@Directive({
  selector: '[gtHasAllOf]'
})
export class GtHasAllOfProductsDirective extends BaseProductsDirective {
  @Input() set gtHasAllOf(parameters: any[]) {
    if (!parameters) {
      return;
    }
    this.authenticationService.hasAllOf(...parameters).subscribe(condition => this.showViewBasedOnCondition(condition));
  }

  constructor(templateRef: TemplateRef<any>, viewContainer: ViewContainerRef, authenticationService: GtAuthenticationService) {
    super(templateRef, viewContainer, authenticationService);
  }
}
